const routes = [
  {
    path: '/badwords/categories',
    name: 'badwords-categories-list',
    component: () => import(/* webpackChunkName: "page/badwords-categories/list" */'@/views/pages/badwords/categories/List'),
    meta: {
      permissions: 'badwords_categories_read'
    }
  },
  {
    path: '/badwords/categories/new',
    name: 'badwords-categories-new',
    component: () => import(/* webpackChunkName: "page/badwords-categories/new" */'@/views/pages/badwords/categories/New'),
    meta: {
      permissions: 'badwords_categories_write'
    }
  },
  {
    path: '/badwords/categories/:id',
    name: 'badwords-categories-single',
    component: () => import(/* webpackChunkName: "page/badwords-categories/single" */'@/views/pages/badwords/categories/Single'),
    meta: {
      permissions: 'badwords_categories_read'
    }
  },
  {
    path: '/badwords/categories/:id/edit',
    name: 'badwords-categories-edit',
    component: () => import(/* webpackChunkName: "page/badwords-categories/edit" */'@/views/pages/badwords/categories/Edit'),
    meta: {
      permissions: 'badwords_categories_write'
    }
  }
]

export default routes
